module.exports = __webpack_public_path__ + "03_long_black.84978c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/03_long_black.png
// module id = mBjT
// module chunks = 0